/**
 * THE canonical order for reference rows that share a (sourceId, refId) pair
 * — the situation a LEGACY `{{ref:<targetId>}}` token creates, since one
 * token id is shared by every row citing that target from that block. There
 * is no `position` column on `Reference` to order occurrences by (see
 * `packages/db/prisma/schema.prisma`), so this ordering is a convention, not
 * derived data: `createdAt` ascending, ties broken by `id` for a total,
 * deterministic order. What matters is that every resolver that has to pick
 * ONE row out of several candidates — `resolveChipRefRow`,
 * `getReferenceRowFromIndex`, `buildReferenceMetaMap` — agrees on this same
 * order, so they don't disagree about which row a chip means.
 */
export type CanonicallyOrderableRow = {
  id: string;
  createdAt?: string;
};

export function compareReferenceRowsCanonical(
  a: CanonicallyOrderableRow,
  b: CanonicallyOrderableRow,
): number {
  const aTime = a.createdAt ? Date.parse(a.createdAt) : 0;
  const bTime = b.createdAt ? Date.parse(b.createdAt) : 0;
  if (aTime !== bTime) return aTime - bTime;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}

export function sortReferenceRowsCanonical<T extends CanonicallyOrderableRow>(
  rows: readonly T[],
): T[] {
  return [...rows].sort(compareReferenceRowsCanonical);
}
